// extracted by mini-css-extract-plugin
module.exports = {"home":"home__2k36g","centering":"centering__38z76"};